export var TOOLTIP_HIDE_TIME = 200;
export var SHADOW_FILTER_ID = 'slice-shadow';
export var TOOLTIP_MOTION = {
    transition: { duration: 0.3 },
    exit: { opacity: 0 },
};
export var TOOLTIP_TIMEOUT = 100;
